<template>
    <div class="skill_div">
        <SkillsPage></SkillsPage>
    </div>
</template>
<script type="text/javascript">
import SkillsPage from '@/components/skill_page/self_score.vue'
import { mapActions } from 'vuex'

export default {
    components: {
        SkillsPage
    },
    methods: {
        ...mapActions({
            set_domain_id: 'skill/set_domain_id',
        })
    },
    created: function () {
        this.set_domain_id(this.$route.params.id)
    }
}



</script>
<style type="text/css">

</style>

